/* gorilla-purchase-toggle.js — Subscribe vs One-time toggle UI */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var options  = document.querySelectorAll('[data-purchase-option]');
    var spInput  = document.querySelector('input[name="selling_plan"]');
    var atcBtn   = document.querySelector('.gorilla-purchase-block__atc');
    var freqWrap = document.getElementById('gorilla-freq-wrap');

    if (!options.length || !spInput) return;

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectOption(opt.getAttribute('data-purchase-option'));
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(opt.getAttribute('data-purchase-option'));
        }
      });
    });

    function selectOption(type) {
      var isSub = type === 'subscribe';

      options.forEach(function (o) {
        var isThisOne = o.getAttribute('data-purchase-option') === type;
        o.classList.toggle('gorilla-buybox__option--active', isThisOne);
        o.setAttribute('aria-checked', isThisOne ? 'true' : 'false');
      });

      /* Update selling_plan input */
      var cfg = window.gorillaRCConfig;
      spInput.value = isSub ? (cfg ? cfg.sellingPlanId : '') : '';
      spInput.dispatchEvent(new Event('change', { bubbles: true }));

      /* Show/hide frequency dropdown */
      if (freqWrap) freqWrap.hidden = !isSub;

      /* Dispatch for other listeners (price display) */
      window.dispatchEvent(new CustomEvent('purchase-mode:change', {
        detail: { mode: type, sellingPlanId: spInput.value }
      }));
    }

    /* Respond to variant changes — keep current mode but refresh any needed state */
    window.addEventListener('variant:change', function () {
      var activeOpt = document.querySelector('[data-purchase-option].gorilla-buybox__option--active');
      if (activeOpt) selectOption(activeOpt.getAttribute('data-purchase-option'));
    });

    /* Default: subscribe on load */
    selectOption('subscribe');
  });
})();
